<template>
  <div class="base-button-container" @click="buttonClicked">
    <div class="base-button" :style="buttonStyle">
      {{text}}
      <font-awesome-icon v-if="icon" class="button-icon" :icon="icon" />
    </div>
  </div>
</template>

<script>
import ResizeText from 'vue-resize-text';

export default {
  name: 'BaseButton',
  directives: {
    ResizeText,
  },
  props: {
    text: {
      type: String,
      required: false,
    },
    icon: {
      type: String,
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'base',
    },
  },
  mounted() {},
  computed: {
    buttonStyle() {
      if (this.disabled) {
        return {
          '--color': this.isDestructive ? '#E32A2A' : '#4B56A9',
          '--hoverColor': this.isDestructive ? '#b51c1c' : '#4B56A9',
          opacity: '0.7',
          cursor: 'not-allowed',
        };
      }
      return {
        '--color': this.isDestructive ? '#E32A2A' : '#4B56A9',
        '--hoverColor': this.isDestructive ? '#b51c1c' : '#622D90',
      };
    },
    isDestructive() {
      return this.type === 'destructive';
    },
  },
  methods: {
    buttonClicked() {
      if (this.disabled) {
        return;
      }
      this.$emit('click');
    },
  },
};
</script>

<style lang="scss" scoped>
.base-button {
  user-select: none;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--color);
  border-radius: 8px;
  color: white;
  cursor: pointer;
  min-height: 40px;
  line-height: 20px;
  font-weight: bold;
  text-align: center;
  padding: 0 10px;
  padding-top: 2px;
  font-size: 70%;
  text-transform: uppercase;
  &:hover {
    background-color: var(--hoverColor);
  }
}
</style>
